import { defineMessages } from 'react-intl';

export const ToggleValues = Object.freeze({
  RECENT: 'Recent',
  A_TO_Z: 'AtoZ',
} as const);

export const TOP_STATIONS_BROWSE_LINK = '/browse/music/top-stations';
export const BEST_OF_PANDORA_BROWSE_LINK = '/browse/best-of-pandora';

export const MyStationDisplayTypes = Object.freeze({
  RECENT: 'Recent',
  A_TO_Z: 'AtoZ',
  MOST_LISTENED: 'MostListened',
} as const);

export const MyStationFilterTypes = Object.freeze({
  RECENTLY_COLLECTED: 'RecentlyCollected',
  RECENT: 'Recent',
  A_TO_Z: 'AtoZ',
  MOST_LISTENED: 'MostListened',
} as const);

export const MyStationSortTypes = Object.freeze({
  RECENTLY_COLLECTED: 'RecentlyCollected',
  RECENT: 'RecentlyPlayed',
  A_TO_Z: 'AtoZ',
  MOST_LISTENED: 'MostListened',
} as const);

export const SORT_BY = Object.freeze({
  alphabetic: 'alphabetic',
  playTime: 'playTime',
  recency: 'recency',
  createdTime: 'createdTime',
} as const);

export const AtoZSort = 'A-Z sort';

export const MyStationsKeys = Object.freeze({
  DISPLAY_TYPE: 'DISPLAY_TYPE',
  LIST_CONFIG: 'LIST_CONFIG',
  LIST_SORT: 'LIST_SORT',
  IS_INITIAL_SORT: 'IS_INITIAL_SORT',
  AVAILABLE_FIELDS: 'AVAILABLE_FIELDS',
  IS_DESC: 'IS_DESC',
  FIELD_VISIBILITY: 'FIELD_VISIBILITY',
} as const);

export const MyStationsActions = Object.freeze({
  SET_MY_STATIONS_DISPLAY: 'SET_MY_STATIONS_DISPLAY',
  SET_MY_STATIONS_DISPLAY_SETTINGS: 'SET_MY_STATIONS_DISPLAY_SETTINGS',
  SET_MY_STATIONS_LIST_SORT: 'SET_MY_STATIONS_LIST_SORT',
  UPDATE_MY_STATIONS_LIST_VISIBLE_FIELDS: 'UPDATE_MY_STATIONS_LIST_VISIBLE_FIELDS',
} as const);

export const messages = defineMessages({
  Recent: {
    id: 't.Recent',
    defaultMessage: 'Recent',
  },
  RecentlyPlayed: {
    id: 't.RecentlyPlayed',
    defaultMessage: 'Recently Played',
  },
  RecentlyCollectedSort: {
    id: 't.RecentlyCollectedSort',
    defaultMessage: 'Sorted by Recently Collected',
  },
  sortLabel: {
    id: 't.sortLabel',
    defaultMessage: 'Sorted by {sort}',
  },
  RecentlyCollected: {
    id: 't.RecentlyCollected',
    defaultMessage: 'Recently Collected',
  },
  AtoZ: {
    id: 't.A-Z',
    defaultMessage: 'A-Z',
  },
  MostListened: {
    id: 't.MostListened',
    defaultMessage: 'Most Listened',
  },
  shuffleStations: {
    id: 't.shuffleStations',
    defaultMessage: 'Shuffle Stations',
  },
  shuffleOn: {
    id: 't.shuffleOn',
    defaultMessage: 'Shuffle Stations On',
  },
  custom: {
    id: 't.custom',
    defaultMessage: 'Custom',
  },
  shuffleAll: {
    id: 't.shuffleAll',
    defaultMessage: 'Shuffle All',
  },
  nowPlaying: {
    id: 't.nowPlaying',
    defaultMessage: 'Now Playing',
  },
  alphabetic: {
    id: 't.alphabetic',
    defaultMessage: 'Station Name',
  },
  recency: {
    id: 't.recency',
    defaultMessage: 'Last Listened',
  },
  createdTime: {
    id: 't.createdTime',
    defaultMessage: 'Date Added',
  },
  thumbs: {
    id: 't.thumbs',
    defaultMessage: 'Thumbs',
  },
  playTime: {
    id: 't.playTime',
    defaultMessage: 'Most Listened',
  },
  addNewStation: {
    id: 't.addNewStation',
    defaultMessage: 'Add New Station',
  },
  shuffle: {
    id: 't.shuffle',
    defaultMessage: 'Shuffle',
  },
} as const);
